import { render, staticRenderFns } from "./AlertListElement.vue?vue&type=template&id=4be24607"
import script from "./AlertListElement.vue?vue&type=script&lang=js"
export * from "./AlertListElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports